import type { SVGProps } from 'react';

export function TransactionOutIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <circle cx="24" cy="24" r="24" fill="url(#paint0_linear_7448_16471)"/>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.2807 30C26.6776 30 26.9996 29.678 26.9996 29.28C26.9996 28.882 26.6776 28.56 26.2807 28.56H20.4579L29.7885 19.2288C30.0705 18.9478 30.0705 18.4918 29.7885 18.2108C29.5075 17.9297 29.0525 17.9297 28.7706 18.2108L19.4399 27.5419V21.7198C19.4399 21.3218 19.118 20.9998 18.72 20.9998C18.323 20.9998 18 21.3218 18 21.7198V29.28C18 29.678 18.323 30 18.72 30H26.2807Z"
        fill="#1C2633"
      />
      <defs>
        <linearGradient
          id="paint0_linear_7448_16471"
          x1="23.4985"
          y1="57.2906"
          x2="57.2234"
          y2="24.1204"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E7FEDE"/>
          <stop offset="1" stopColor="#79F748"/>
        </linearGradient>
      </defs>
    </svg>
  );
}
